import { SubCategory } from "../Model/SubCategory";
import { SubCategoryRepository } from "../Repository/SubCategoryRepository";

export interface CreateCategoryUseCase {
  invoke: (data: SubCategory) => Promise<boolean>;
}

export class CreateSubCategory implements CreateCategoryUseCase {

  private subCategoryRepo: SubCategoryRepository;

  constructor(_SubCategoryRepo: SubCategoryRepository) {
    this.subCategoryRepo = _SubCategoryRepo;
  }

  async invoke(data: SubCategory){

    if(!data){
        throw new Error(
            "Your todo should have at leat 2 characters."
          );
    }
     
    const created  = await this.subCategoryRepo.createSubCategory(data);
    return created;
  }
}